import PublicOutlined from '@mui/icons-material/PublicOutlined';
import { InputAdornment } from '@mui/material';
import { useListTimezonesQuery } from 'api/client-domain/client-domain';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import AutocompleteField from '../autocomplete-field/autocomplete-field.component';

type TimezoneFieldProps = {
  helperText?: string;
  name: string;
  'data-testid'?: string;
  sx?: object;
  value?: string;
};

const TimezoneField = ({
  helperText,
  name = 'timeZone',
  'data-testid': dataTestId = 'TimezoneField',
  ...rest
}: TimezoneFieldProps) => {
  const { t } = useTranslation();
  const { data } = useListTimezonesQuery({});
  const options = useMemo(() => {
    return data?.timezones.map(timezone => ({
      label: timezone.windowsDisplayName,
      id: timezone.olsonName,
    }));
  }, [data?.timezones]);

  return (
    <AutocompleteField
      name={name}
      options={options}
      label={t('forms.fields.timeZone.label')}
      data-testid={dataTestId}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <PublicOutlined />
          </InputAdornment>
        ),
      }}
      TextFieldProps={{
        placeholder: t('forms.fields.timeZone.placeholder'),
      }}
      {...rest}
    />
  );
};

export default TimezoneField;
